import { EncounterMedicationsBlockNode as EncounterMedicationsBlockSchema } from '@seen/core/tiptap/schema'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { EncounterMedicationsBlockView } from '#src/components/rich-text-editor/EncounterMedicationsBlockNode/EncounterMedicationsBlockView.tsx'

export interface EncounterMedicationsBlockNodeOptions {
  patientReferenceString?: string
}

export const EncounterMedicationsBlockNode =
  EncounterMedicationsBlockSchema.extend<EncounterMedicationsBlockNodeOptions>({
    addOptions() {
      return {
        patientReferenceString: undefined,
      }
    },

    addNodeView() {
      return ReactNodeViewRenderer(EncounterMedicationsBlockView)
    },
  })
